// import React, { useState, useEffect } from "react";
import { Container, Row, Col, Badge } from "react-bootstrap";
import {
  FaPhoneAlt,
  //FaEnvelope,
  FaMapMarkerAlt,
  FaGlobe,
  FaCogs,
  FaShieldAlt,
  FaArrowUp,
} from "react-icons/fa";

export default function Footer({ partners, footerServices, locations }) {
  const blue = "#0062A0";
  const magenta = "#E91E63";

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer-gradient-section pt-5 pb-3">
      <Container>
        <Row className="g-4 mb-5">
          <Col lg={4} md={12}>
            <div className="footer-brand mb-4 text-white">
              <h3 className="fw-bold mb-1">RADHEY ELECTRICAL </h3>
              <Badge
                bg="none"
                className="p-0 text-uppercase"
                style={{
                  color: "#fff",
                  opacity: 0.9,
                  letterSpacing: "1px",
                  fontSize: "0.75rem",
                }}
              >
                <FaShieldAlt className="me-1" /> Gov. Approved Electrical
                Contractor
              </Badge>
            </div>
            <p
              className="small text-white-50 mb-4"
              style={{ lineHeight: "1.7" }}
            >
              Prominent service provider in Gujarat & Rajasthan. Specialists in
              Absolute & Professional testing...
            </p>
            <div className="d-flex flex-wrap gap-2">
              {partners.map((item) => (
                <span key={item.id} className="tiny-brand-tag-glass">
                  {item.title}
                </span>
              ))}
            </div>
          </Col>

          <Col lg={2} md={6}>
            <div className="d-flex align-items-center mb-4 text-white">
              <FaCogs className="me-2" />
              <h6 className="fw-bold mb-0">Services</h6>
            </div>
            <ul className="list-unstyled footer-links-glass small">
              {footerServices.map((service) => (
                <li key={service.id}>{service.title}</li>
              ))}
            </ul>
          </Col>

          {locations.map((loc) => (
            <Col lg={3} md={6} key={loc.id} className="text-white">
              <h6 className="fw-bold mb-4 opacity-75">{loc.title}</h6>
              <div className="d-flex mb-3 small align-items-start">
                <FaMapMarkerAlt className="me-3 mt-1" />
                <span className="text-white-50">{loc.subtitle}</span>
              </div>
              {loc.extra_info &&
                loc.extra_info.split(",").map((phone, index) => (
                  <div
                    key={index}
                    className="d-flex mb-2 small align-items-center"
                  >
                    <FaPhoneAlt className="me-3" />
                    <span className="fw-bold">{phone.trim()}</span>
                  </div>
                ))}
              <div className="d-flex small align-items-center">
                {loc.title.toLowerCase().includes("head") ? (
                  <>
                    {/* <FaEnvelope className="me-3" />
                    <span className="text-white-50">{loc.contact_email}</span> */}
                  </>
                ) : (
                  <>
                    <FaGlobe className="me-3" />
                    <span className="text-white-50">
                      www.radheyelectrical.com
                    </span>
                  </>
                )}
              </div>
            </Col>
          ))}
        </Row>
        <hr className="my-4 border-white opacity-25" />

        {/* Bottom Bar */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white-50">
          <p className="small mb-0">
            © {new Date().getFullYear()} Radhey Electrical. All Rights Reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="scroll-top-btn-glass mt-3 mt-md-0 shadow-sm"
            aria-label="Scroll to top"
          >
            <FaArrowUp />
          </button>
        </div>
      </Container>

      <style>
        {`
          .footer-gradient-section {
            background: linear-gradient(135deg, ${blue} 0%, #003d63 50%, ${magenta} 150%);
            position: relative;
            overflow: hidden;
          }
          .footer-gradient-section::before {
            content: "";
            position: absolute;
            top: 0; left: 0; right: 0; bottom: 0;
            background-image: radial-gradient(rgba(255,255,255,0.05) 1px, transparent 1px);
            background-size: 20px 20px;
            pointer-events: none;
          }
          .footer-links-glass li {
            margin-bottom: 12px;
            color: rgba(255,255,255,0.7);
            transition: 0.3s;
            cursor: pointer;
            list-style: none;
          }
          .footer-links-glass li:hover {
            color: #fff;
            transform: translateX(5px);
          }
          .tiny-brand-tag-glass {
            font-size: 0.65rem;
            font-weight: bold;
            color: rgba(255,255,255,0.8);
            padding: 4px 10px;
            background: rgba(255,255,255,0.1);
            backdrop-filter: blur(5px);
            border-radius: 6px;
            border: 1px solid rgba(255,255,255,0.2);
          }
          .scroll-top-btn-glass {
            width: 42px; height: 42px; border-radius: 50%;
            background: rgba(255,255,255,0.1); backdrop-filter: blur(10px);
            color: white; border: 1px solid rgba(255,255,255,0.3);
            display: flex; align-items: center; justify-content: center;
            transition: 0.3s;
          }
          .scroll-top-btn-glass:hover {
            background: #fff; color: ${blue}; transform: translateY(-5px);
          }
          @media (max-width: 768px) {
            .footer-gradient-section { text-align: center; }
            .d-flex { justify-content: center; }
          }
        `}
      </style>
    </footer>
  );
}
